import React, { Component } from 'react'
import Footer from '../../../_components/common/Footer';
import NavBar from '../../../_components/common/Navbar';
import ModalNew2 from '../../../_components/common/ModalNew2';
import { validation, cellValidation } from './validation';
import { HotTable } from '@handsontable/react';
import 'handsontable/dist/handsontable.full.css'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../_components/common/Form2/index.css';
import { connect } from 'react-redux';
import * as Papa from 'papaparse';
import { UploadDemographicDataAction } from '../../../_actions/UploadDemoGraphicData/UploadDemographicData.action'
import './index.css'
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';



class UploadDemographicData extends Component {
    state = {
        chooseFile: false,
        csvData: [],
        validateDisability: false,
        uploadDisability: false,
        csvErrorPosition: {},
        work_experience: 50,
        validationText: 'VALIDATE',
        errSaveIndex: []
    }

    componentDidUpdate(prevProps) {
        const { demoGraphicCsvUpload } = this.props
        if (prevProps.demoGraphicCsvUpload !== demoGraphicCsvUpload) {
            if (demoGraphicCsvUpload.demoGraphicCsvUpload_error === false && demoGraphicCsvUpload.demoGraphicCsvUpload_loading === false) {

                let toastIdDemoGrpahicUpload = toast['info'](`CSV UPLOADED SUCCESSFULLY`, {
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 1500,
                });

                toast.update(toastIdDemoGrpahicUpload, {
                    render: demoGraphicCsvUpload.demoGraphicCsvUpload_response.data.message,
                    type: toast.TYPE.INFO,
                    className: 'styleToastSuccess'
                })
            } else if (demoGraphicCsvUpload.demoGraphicCsvUpload_error === true) {
                let toastIdDemoGrpahicUpload = toast['error'](`CSV UPLOAD FAILED`, {
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 1500,
                });
            }
        }
    }

    chooseFileFunc = (showModal) => {
        this.setState({
            chooseFile: showModal
        })
    }
    chooseFileAction = (data) => {
        let that = this
        Papa.parse(data, {
            complete: function (results) {
                let __validCsv = 0;
                for (let i = 0; i < 1; i++) {
                    const element = results.data[i];
                    for (let j = 0; j < element.length; j++) {
                        const elem = element[j];
                        if (elem === 'sl_no' || elem === 'user_email' || elem === 'full_name' || elem === 'short_name' || elem === 'gender' || elem === 'date_of_birth' || elem === 'alternate_email' || elem === 'work_experience' || elem === 'city' || elem === 'designation' || elem === 'marital_status' || elem === 'tenure_in_company' || elem === 'industry' || elem === 'occupation' || elem === 'qualification') {
                            __validCsv++
                        }
                    }
                }
                if (__validCsv === 15) {
                    let currentDate = new Date().getTime();
                    let properCsvData = [];
                    let errorCounterForValidDate = false
                    results.data.map((val, key) => {
                        if (key !== 0) {
                            let arrayToThisLocation = []
                            val.map((value, index) => {

                                arrayToThisLocation.push(value)
                            })
                            properCsvData.push(arrayToThisLocation)
                        } else {
                            properCsvData.push(val)
                        }
                    })

                    that.setState({
                        csvData: properCsvData,
                    }, () => {
                        if (that.state.currentInstrumentId !== 0) {
                            that.setState({
                                validateDisability: true
                            })
                        }
                    })
                } else {
                    that.setState({
                        csvData: [],
                        errSaveIndex: [],
                        validateDisability: false,
                    }, () => {
                        toast.error(`CSV FORMAT DOESNT MATCH`, {
                            position: toast.POSITION.BOTTOM_CENTER,
                            autoClose: 1500,
                        });
                    })
                }
                that.setState({

                    uploadDisability: false
                })
            }
        });
    }
    validateCsvFunc = () => {

        if (this.state.uploadDisability === false) {
            if (this.state.csvData.length !== 0) {
                let csvValidationState = true;
                let csvError = {
                    column: '',
                    row: {},
                    element: ''
                }
                let csvArray = this.csvJSON(this.state.csvData)

                let emptyArrId = [];
                let saveIndex = [];
                for (let i = 0; i < csvArray.length; i++) {
                    const element = csvArray[i];

                    if (element.sl_no === '' && element.user_email === '' && element.full_name === '' && element.short_name === '' && element.gender === '' && element.date_of_birth === '' && element.country_code === '' && element.alternate_email === '' && element.city === '' && element.occupation === '' && element.designation === '' && element.work_experience === '' && element.marital_status === '' && element.industry === '' && csvArray.length !== 1) {

                        emptyArrId.push(i)
                    } else if (validation.isNumber(element.sl_no) !== true || validation.isEmailAddress(element.user_email) !== true || validation.isFullName(element.full_name) !== true || validation.isShortName(element.short_name) !== true || validation.isGender(element.gender) !== true || validation.isProperDate(element.date_of_birth) !== true || validation.isCountryCode(element.country_code) !== true || validation.isAlternateMail(element.alternate_email) !== true || validation.isCity(element.city) !== true || validation.isOccupation(element.occupation) !== true || validation.isDesignation(element.designation) !== true || validation.isWorkExperience(element.work_experience) !== true || validation.marriedState(element.marital_status) !== true || validation.isIndustry(element.industry) !== true || validation.isQualification(element.qualification) !== true || validation.isTenureInCompany(element.work_experience, element.tenure_in_company) !== true) {
                        if (csvValidationState) {
                            csvValidationState = false
                        }
                    }

                    let saveColumnIndex = []

                    if (element.sl_no === '') {
                        saveColumnIndex.push(0)
                    } else if (!validation.isNumber(element.sl_no)) {
                        saveColumnIndex.push(0)
                    }



                    if (element.user_email === '') {
                        saveColumnIndex.push(1)
                    } else if (!validation.isEmailAddress(element.user_email)) {
                        saveColumnIndex.push(1)
                    }

                    if (element.full_name === '') {
                        saveColumnIndex.push(2)
                    } else if (!validation.isFullName(element.full_name)) {
                        saveColumnIndex.push(2)
                    }

                    if (!validation.isGender(element.gender)) {
                        saveColumnIndex.push(4)
                    }

                    if (element.date_of_birth === '') {
                        saveColumnIndex.push(5)
                    } else if (!validation.isProperDate(element.date_of_birth)) {
                        saveColumnIndex.push(5)
                    }

                    if (!validation.isCountryCode(element.country_code)) {
                        saveColumnIndex.push(6)
                    }

                    if (!validation.isAlternateMail(element.alternate_email)) {
                        saveColumnIndex.push(7)
                    }

                    saveIndex.push({
                        col: saveColumnIndex,
                        row: i + 1
                    })

                }
                for (let i = 0; i < emptyArrId.length; i++) {
                    const element = emptyArrId[i];
                    csvArray.splice(element - i, 1)
                }
                let arrayCsv = []
                for (let i = 0; i < csvArray.length; i++) {
                    const element = csvArray[i];
                    if (i === 0) {
                        arrayCsv.push(Object.keys(element))
                    }
                    arrayCsv.push(Object.values(element))
                }

                if (csvValidationState === false) {
                    let toastId1 = toast['error'](`CSV VALIDATION FAILED`, {
                        position: toast.POSITION.BOTTOM_LEFT,
                        autoClose: 1500,
                    });

                    this.showErrorHighlightHOT(saveIndex)

                    this.setState({
                        uploadDisability: false
                    })
                } else if (csvValidationState === true) {
                    let toastId1 = toast['info'](`CSV VALIDATED SUCCESSFULLY`, {
                        position: toast.POSITION.BOTTOM_LEFT,
                        autoClose: 1500,
                    });

                    toast.update(toastId1, {
                        render: `CSV VALIDATED SUCCESSFULLY`,
                        type: toast.TYPE.INFO,
                        className: 'styleToastSuccess'
                    })
                    this.setState({
                        csvData: arrayCsv,
                        uploadDisability: !this.state.uploadDisability,
                        validationText: 'EDIT CSV'
                    })

                }
            }
        } else if (this.state.uploadDisability === true) {
            this.setState({
                uploadDisability: !this.state.uploadDisability,
                validationText: 'VALIDATE'
            })
        }
    }

    cellbeforechange = (c, s) => {
        this.state.csvData[c[0][0]][c[0][1]] = c[0][3]
        let editedErrored = false

        this.state.errSaveIndex.map(indexes => {
            indexes.col.map(colD => {
                if (c[0][0] === indexes.row && c[0][1] === colD) {
                    if (c[0][2] !== c[0][3]) {
                        editedErrored = true
                    }
                }
            })
        })

        if (editedErrored) {
            const errorIndexArr = this.state.errSaveIndex.map(indexes => {
                return {
                    ...indexes,
                    col: indexes.col.filter(colD => {
                        return indexes.row !== c[0][0] || (indexes.row === c[0][0] && colD !== c[0][1])
                    })
                }
            })

            this.setState({
                errSaveIndex: errorIndexArr
            })
        }
    }



    showErrorHighlightHOT(saveIndex) {
        this.setState({
            errSaveIndex: saveIndex,
        })
    }

    hotAfterValidate = (isValid, value, row, prop, source) => {

    }


    isTenureInCompany = (str, callback) => {
        let intStr = parseFloat(str)
        let intWorkExp = parseFloat(this.state.work_experience)

        if (intStr > intWorkExp) {
            callback(false)
        } else {
            callback(true)
        }
    }

    uploadCsvFunc = () => {

        const { dispatch } = this.props;

        let csvJson = this.csvJSON(this.state.csvData)
        let uploadingData = []

        for (let i = 0; i < csvJson.length; i++) {
            const element = csvJson[i];
            if (element.date_of_birth !== undefined) {
                if (element.date_of_birth.includes('Jan')) {
                    element.date_of_birth = element.date_of_birth.replace("Jan", "01")
                } else if (element.date_of_birth.includes('Feb')) {
                    element.date_of_birth = element.date_of_birth.replace("Feb", "02")
                } else if (element.date_of_birth.includes('Mar')) {
                    element.date_of_birth = element.date_of_birth.replace("Mar", "03")
                } else if (element.date_of_birth.includes('Apr')) {
                    element.date_of_birth = element.date_of_birth.replace("Apr", "04")
                } else if (element.date_of_birth.includes('May')) {
                    element.date_of_birth = element.date_of_birth.replace("May", "05")
                } else if (element.date_of_birth.includes('Jun')) {
                    element.date_of_birth = element.date_of_birth.replace("Jun", "06")
                } else if (element.date_of_birth.includes('Jul')) {
                    element.date_of_birth = element.date_of_birth.replace("Jul", "07")
                } else if (element.date_of_birth.includes('Aug')) {
                    element.date_of_birth = element.date_of_birth.replace("Aug", "08")
                } else if (element.date_of_birth.includes('Sep')) {
                    element.date_of_birth = element.date_of_birth.replace("Sep", "09")
                } else if (element.date_of_birth.includes('Oct')) {
                    element.date_of_birth = element.date_of_birth.replace("Oct", "10")
                } else if (element.date_of_birth.includes('Nov')) {
                    element.date_of_birth = element.date_of_birth.replace("Nov", "11")
                } else if (element.date_of_birth.includes('Dec')) {
                    element.date_of_birth = element.date_of_birth.replace("Dec", "12")
                }

                const a = [{
                    "action": "update",
                    "country_code": ",",
                    "date_of_birth": "1989-03-15",
                    "full_name": "Noel lobo",
                    "short_name": "",
                    "sl_no": "1",
                    "user_email": "noel.l@pacewisdom.com",

                    "gender": "",
                    "details":
                    {
                        "alternate_email": "",
                        "work_experience": "3.6",
                        "city": "",
                        "designation": "Manager",
                        "marital_status": "",
                        "tenure_in_company": "0.1",
                        "industry": "",
                        "occupation": "M1",
                        "qualification": "PG Diploma"
                    }
                }]

                var newdate = '';

                if (element.date_of_birth.includes('/')) {
                    newdate = element.date_of_birth.split("/").reverse().join("-");
                } else if (element.date_of_birth.includes('-')) {
                    newdate = element.date_of_birth.split("-").reverse().join("-");
                }
                element.date_of_birth = newdate

            }
            if (element.marital_status !== undefined) {
                if (element.marital_status !== '') {
                    let lowerCaseStr = element.marital_status.toLowerCase()
                    if (lowerCaseStr === 'single') {
                        element.marital_status = "1"
                    } else if (lowerCaseStr === 'married') {
                        element.marital_status = "2"
                    } else if (lowerCaseStr === 'divorced') {
                        element.marital_status = "3"
                    } else if (lowerCaseStr === 'widow') {
                        element.marital_status = "4"
                    }
                }
            }
            if (element.gender !== undefined) {
                if (element.gender !== '') {
                    let lowerCaseStr = element.gender.toLowerCase()
                    if (lowerCaseStr === 'male') {
                        element.gender = "1"
                    } else if (lowerCaseStr === 'female') {
                        element.gender = "2"
                    } else if (lowerCaseStr === 'other') {
                        element.gender = "3"
                    }
                }
            }


            if (element.country_code !== undefined) {
                if (element.country_code === '') {
                    element.country_code = null
                }
            }

            let dataObj = {

                "user_email": element.user_email,
                "full_name": element.full_name,
                "short_name": element.short_name,
                "gender": element.gender,
                "date_of_birth": element.date_of_birth,
                "country_code": element.country_code,

                "details": {
                    "alternate_email": element.alternate_email,

                    "work_experience": element.work_experience.trim().length ? element.work_experience : "0",

                    "city": element.city,

                    "designation": element.designation,

                    "marital_status": element.marital_status,
                    "tenure_in_company": element.tenure_in_company.trim().length ? element.tenure_in_company : "0",

                    "industry": element.industry,

                    "occupation": element.occupation,
                    "qualification": element.qualification,

                }
            }
            uploadingData.push(dataObj)
        }



        dispatch(UploadDemographicDataAction.uploadCsvAction(uploadingData))

    }

    csvJSON(csv) {

        var lines = csv;

        var result = [];

        var headers = lines[0];

        for (var i = 1; i < lines.length; i++) {

            var obj = {};
            var currentline = lines[i];

            for (var j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentline[j];
            }

            result.push(obj);

        }


        return result;
    }

    afterChange(changes, source) {
        if (changes !== null) {
            let changedRow = changes[0][0];
            for (let i = 0; i < changes.length; i++) {
                const element = changes[i];
                if (changedRow !== element[0]) {
                    changedRow = element[0]
                }
            }
            if (changedRow === changes[0][0]) {
                let counter = changes.length;
                for (let i = 0; i < changes.length; i++) {
                    const element = changes[i];
                    if (element[3].trim().length === 0) {
                        counter--
                    }

                }

                if (counter === 0) {
                    let csvData = [...this.state.csvData];
                    csvData.splice(changes[0][0], 1)
                    this.setState({
                        csvData
                    })
                }
            }
        }
    }

    render() {
        return (
            <div className="position-relative  custom-container-footer">
                <NavBar />
                <div className="container" style={{ marginTop: 20, marginBottom: 20, }}>
                    <div className="bg-green rounded-top mt-5 animation-fade-in">
                        <CommonBreadCrumb
                            data={[
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'UPLOAD - DEMOGRAPHIC DATA'
                                }
                            ]}
                        />

                        <p className="text-center text-uppercase py-2 text-white mb-0">CSV Uploads - demographic masters</p>
                    </div>
                    <div className="container animation-fade-in" style={{ backgroundColor: '#5e5e5e' }}>
                        <div className="row p-2" >
                            <div className="pl-2 pr-2" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <button className="btn btn-red btn-sm text-uppercase m-1" onClick={() => this.chooseFileFunc(true)}>
                                    CHOOSE FILE
                                </button>
                                <button className="btn btn-red btn-sm text-uppercase m-1" disabled={!this.state.validateDisability} onClick={() => this.validateCsvFunc()}>
                                    {this.state.validationText}
                                </button>
                                <button className="btn btn-red btn-sm text-uppercase m-1" disabled={!this.state.uploadDisability} onClick={() => this.uploadCsvFunc()}>
                                    UPLOAD
                                </button>
                            </div>
                        </div>
                    </div>
                    <div >
                        <HotTable
                            data={this.state.csvData}
                            colHeaders={true}
                            rowHeaders={true}
                            beforeChange={this.cellbeforechange}

                            width="100%"
                            height="600"
                            stretchH="all"
                            readOnly={this.state.uploadDisability}
                            columns={[{
                                validator: cellValidation.isNumber,
                                allowInvalid: true
                            },

                            {
                                validator: cellValidation.isEmailAddress,
                                placeholder: 'Email address',
                                placeholderCellClassName: 'hot-placeholder',
                            }, {
                                validator: cellValidation.isFullName,
                            }, {
                                validator: cellValidation.isShortName,
                                placeholder: 'Less than 15 letters',
                                placeholderCellClassName: 'hot-placeholder',
                            }, {
                                validator: cellValidation.isGender,
                                placeholder: 'Must be Male, Female or Other',
                                placeholderCellClassName: 'hot-placeholder',
                            }, {
                                validator: cellValidation.isProperDateOfBirth,
                                placeholder: 'eg: 01/Jan/2018',
                                placeholderCellClassName: 'hot-placeholder',
                            }, {
                                validator: cellValidation.isCountryCode,
                                placeholder: 'eg: IN',
                                placeholderCellClassName: 'hot-placeholder',
                            }, {
                                validator: cellValidation.isAlternateMail,
                            }, {
                                validator: cellValidation.isWorkExperience,
                            }, {
                                validator: cellValidation.isCity,
                            }, {
                                validator: cellValidation.isDesignation,
                            }, {
                                validator: cellValidation.marriedState,
                            }, {
                                validator: this.isTenureInCompany,
                            }, {
                                validator: cellValidation.isIndustry
                            }, {
                                validator: cellValidation.isOccupation,
                            }, {
                                validator: cellValidation.isQualification
                            },

                            ]}
                            afterValidate={this.hotAfterValidate}
                            cells={(row, col, prop) => {
                                var cellProperties = {};

                                if (row === 0) {
                                    cellProperties.readOnly = true;
                                }

                                this.state.errSaveIndex.map(indexes => {
                                    indexes.col.map(colD => {
                                        if (row === indexes.row && col === colD) {
                                            cellProperties.className = 'cellErrorInvalid';
                                        }
                                    })
                                })




                                return cellProperties;
                            }}
                        />
                    </div>
                </div>
                {
                    this.state.chooseFile === true &&
                    <ModalNew2
                        heading="CHOOSE FILE"
                        showModal={this.state.chooseFile}
                        formData={[{
                            key: 'chooseFile',
                            type: 'file',
                            accept: '.csv',
                            value: '',
                            valid: false,
                            regex: ".+",
                            elementConfig: {
                                name: 'chooseFile',
                                label: '',
                                placeholder: 'Choose a file'
                            },
                            validation: {
                                required: false,
                                message: "is required"
                            },
                        },]}
                        action={this.chooseFileAction.bind(this)}
                        toggleModal={this.chooseFileFunc.bind(this)}
                        viewMessage={[{ text: '' }]}
                        triggerType={"CANCEL"}
                        singleButton={true}
                        onlyCancel={true}
                    />
                }
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = state => (
    {
        demoGraphicCsvUpload: state.demoGraphicCsvUpload
    }
)

export default connect(mapStateToProps)(UploadDemographicData)


// WEBPACK FOOTER //
// ./src/_pages/Admin/UploadDemographicData/index.jsx